// views/auth/register.en.js  (EN)
export const register_i18n = {
  alts: {
    banner: "registration background",
    brand: "WA Checkin",
    footerLogo: "WA Checkin",
  },

  aria: {
    toggleReferral: "turn the affiliate code on or off",
    togglePassword: "show or hide password",
  },

  texts: {
    inviteTitle: "Congratulations!",
    inviteText: "{name} invited you to WACheckin: you get {percent}% off your first {months} months.",
    inviteApplied: "Applied from your invitation link.",
    panelKicker: "WACheckin · 2026",
    panelCta: "Discover WACheckin",
    langLabel: "Language",
    panelTitle: "Set it up once. The rest runs itself.",
    panelDesc: "The check-in link, the welcome message, the keys and the police report all go out without you having to remember.",
    title: "Create your account",
    infoTitle: "Sign up in minutes",
    infoDesc:
      "Fill in your details and start automating check-in and guest communication.",
    referralHint: "Turn it on only if you were given one.",
    alreadyHaveAccount: "Already have an account?",
  },

  labels: {
    inviteCode: "Invitation code",
    name: "Name",
    email: "Email",
    password: "Password",
    phone: "Phone",
    referralCode: "Affiliate code",
  },

  placeholders: {
    name: "Enter your name",
    email: "Enter your email",
    password: "Create a password",
    referralCode: "Code",
  },

  buttons: {
    submit: "Create account",
    submitting: "Creating account...",
    signIn: "Sign in",
  },

  validation: {
    phoneRequired: "Enter your number, not just the dialling code.",
    phoneInvalid: "That number isn't valid. Please check it.",
    invalidReferralCode: "The affiliate code is not valid.",
  },

  toast: {
    signupSuccess: "Account created successfully!",
    referralCodeError:
      "The referral code is not correct. Enter a valid one or leave the field empty.",
    signupError: "Error while signing up.",
    networkError: "Connection error. Please try again.",
  },
};
